<template>
  <div>

  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('logout')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/authentication/Logout.vue